import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useRef, useEffect } from 'react';
import { identity } from 'ramda';
import { useInView as useInViewLib, InViewHookResponse, IntersectionOptions } from 'react-intersection-observer';
import { useBooleanState } from '../useBooleanState';

/* istanbul ignore next */
var loadIntersectionObserver = identity(function () {
  return import('intersection-observer');
});
var hasNativeIntersectionObserver = typeof IntersectionObserver !== 'undefined';

/** Состояние модуля, показывает, загружался ли уже полифилл ранее */
var isPolyfillLoadedBefore = false;

/**
 * Хук оборачивает оригинальный useInView, добавляя загрузку полифилла при необходимости
 * В случае, если IntersectionObserver нативно не поддерживается и еще не загрузился, хук вернет пустую рефку
 * Пустая рефка не запускает использование IntersectionObserver, поэтому ошибка не возникает
 * */
export var useInView = hasNativeIntersectionObserver ? useInViewLib : function (args) {
  var noopRef = useRef(null);
  var result = useInViewLib(args);
  var _useBooleanState = useBooleanState(isPolyfillLoadedBefore),
    _useBooleanState2 = _slicedToArray(_useBooleanState, 2),
    isPolyfillLoaded = _useBooleanState2[0],
    setPolyfillLoaded = _useBooleanState2[1];
  useEffect(function () {
    /** Если полифилл уже загружен, не нужно делать ничего лишнего */
    if (isPolyfillLoadedBefore) {
      return;
    }
    var componentStillMounted = true;
    loadIntersectionObserver().then(function () {
      isPolyfillLoadedBefore = true;

      /**
       * Если компонент к моменту загрузки полифилла уже размаунтился, стейт обновлять не нужно.
       * Сложно протестить
       * */
      /* istanbul ignore next */
      if (componentStillMounted) {
        setPolyfillLoaded();
      }
    }).catch(function () {
      return null;
    });
    return function () {
      componentStillMounted = false;
    };
  }, [setPolyfillLoaded]);
  return isPolyfillLoaded ? result : _objectSpread(_objectSpread({}, result), {}, {
    ref: noopRef
  });
};
export { InViewHookResponse, IntersectionOptions };